"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = Breadcrumbs;
exports.BreadcrumbsItem = BreadcrumbsItem;
exports.BreadcrumbsProvider = BreadcrumbsProvider;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BreadcrumbsCtx = (0, _react.createContext)({
  items: new Map(),
  register: () => {},
  unregister: () => {}
});
let nextId = 0;
function BreadcrumbsProvider({
  children
}) {
  const itemsRef = (0, _react.useRef)(new Map());
  const [revision, setRevision] = (0, _react.useState)(0);
  const register = (0, _react.useCallback)((id, props) => {
    itemsRef.current.set(id, props);
    setRevision(r => r + 1);
  }, []);
  const unregister = (0, _react.useCallback)(id => {
    itemsRef.current.delete(id);
    setRevision(r => r + 1);
  }, []);
  const value = _react.default.useMemo(() => ({
    items: itemsRef.current,
    register,
    unregister
  }), [register, unregister, revision]);
  return _react.default.createElement(BreadcrumbsCtx.Provider, {
    value: value
  }, children);
}
function BreadcrumbsItem({
  children,
  ...props
}) {
  const {
    register,
    unregister
  } = (0, _react.useContext)(BreadcrumbsCtx);
  const idRef = (0, _react.useRef)(null);
  if (idRef.current === null) {
    idRef.current = ++nextId;
  }
  const propsKey = props.to;
  (0, _react.useEffect)(() => {
    register(idRef.current, {
      ...props,
      children
    });
    return () => unregister(idRef.current);
  }, [register, unregister, children, propsKey]);
  return null;
}
BreadcrumbsItem.propTypes = {
  to: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
};
function Breadcrumbs({
  container: Container,
  item: Item,
  finalProps,
  compare,
  removeProps
}) {
  const {
    items
  } = (0, _react.useContext)(BreadcrumbsCtx);
  let entries = Array.from(items.values());
  if (compare) {
    entries.sort(compare);
  }
  const stripped = entries.map(entry => {
    if (!removeProps) return entry;
    const copy = {
      ...entry
    };
    Object.keys(removeProps).forEach(key => {
      delete copy[key];
    });
    return copy;
  });
  const rendered = stripped.map((itemProps, idx) => {
    const isLast = idx === stripped.length - 1;
    const mergedProps = isLast && finalProps ? {
      ...itemProps,
      ...finalProps
    } : itemProps;
    return _react.default.createElement(Item, (0, _extends2.default)({
      key: idx
    }, mergedProps));
  });
  return Container ? _react.default.createElement(Container, null, rendered) : _react.default.createElement(_react.default.Fragment, null, rendered);
}